import { PlatformUtility } from 'utility-ts-platform';
interface INotificationConfig {
  content: string;
  timeout: number;
  dismissOnTimeout: boolean;
}

export class NotifyUserService {
  isDesktop: boolean;
  __notificationSettingsNotification: any;
  notificationConfig: INotificationConfig;

  constructor(private phxNotificationDelegate: any, private log: any) {
    this.__notificationSettingsNotification = this.phxNotificationDelegate.restrictTo('app-alerts');
    this.isDesktop = PlatformUtility.isDesktop();
    this.notificationConfig = {
      content: '',
      timeout: 4000,
      dismissOnTimeout: true
    };
  }

  notifySuccess(message: string) {
    this.notificationConfig.content = message;
    this.isDesktop
      ? this.__notificationSettingsNotification.success({ ...this.notificationConfig, content: message })
      : this.log.user.success(message);
  }

  notifyError(message: string) {
    this.notificationConfig.content = message;
    this.isDesktop
      ? this.__notificationSettingsNotification.error({ ...this.notificationConfig, content: message })
      : this.log.user.error(message);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/services/notify_user_service.ts